const INTERNAL_DOMAINS = [
  "@noxus.ai",
  "@spot-technologies.com",
  "@spot-network.com",
  // The e2e suite signs in as an @noxus-testing.com user and drives the
  // Noxus-only surfaces. Safe to keep listed: this gates UI only and is never
  // an authorization boundary — see the note in spotUser.tsx.
  "@noxus-testing.com",
] as const;

// People outside Noxus who get the Noxus-only surfaces (the Genie settings),
// one exact lowercase address per entry.
const INTERNAL_EMAILS: readonly string[] = [];

export function isNoxusInternal(email: string): boolean {
  const normalized = email.toLowerCase();
  return (
    INTERNAL_DOMAINS.some((domain) => normalized.endsWith(domain)) ||
    INTERNAL_EMAILS.includes(normalized)
  );
}
